import { render, staticRenderFns } from "./WfChip.vue?vue&type=template&id=86e1a86e"
var script = {}
import style0 from "./WfChip.vue?vue&type=style&index=0&id=86e1a86e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports